export default "__VITE_ASSET__CadYBWuu__"